export namespace RifoExlusiveStates {
    export function rifoExlusiveListStatesFactory() {
        const rifoExlusiveListStates = {
            reload: new Date()
        };
        return rifoExlusiveListStates;
    }

    export function mutations() {
        return {
            rifoExlusiveListReload(state: any) {
                state.rifoExlusiveListStates.reload = new Date();
            }
        };
    }
}
